import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { MonthlyChargeAccounting } from '../models/monthlyChargesAccounting';

const BASE_URL = environment.base_url_second;

@Injectable({
  providedIn: 'root'
})
export class MonthlyChargesAccountingService {

  constructor(
    private httpClient: HttpClient
  ) { }


  findAll(): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesAccounting`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Los clinicIds son string separados por una coma (Ejemplo: "1234,1233,1222")
  findByClientAndClinics(clientId: string, clinicIds: string, yearMonth: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesAccountingClientAndClinics?clientId=${clientId}&clinicIds=${clinicIds}&yearMonth=${yearMonth}`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Si le pedimos 2 months back por ejemplo, nos devolverá el mes actual + 2 meses anteriores.
  findByMonthsBackAndDistributor(distributorID: string, monthsBack: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesByMonthsBack?entityType=distributor&distributorID=${distributorID}&monthsBack=${monthsBack}`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Si le pedimos 2 months back por ejemplo, nos devolverá el mes actual + 2 meses anteriores.
  findByMonthsBackAndClient(distributorID: string, clientID: string, monthsBack: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesByMonthsBack?entityType=client&distributorID=${distributorID}&clientID=${clientID}&monthsBack=${monthsBack}`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Si le pedimos 2 months back por ejemplo, nos devolverá el mes actual + 2 meses anteriores.
  findByMonthsBackAndParentId(parentId: string, monthsBack: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesByMonthsBack?entityType=client&distributorID=${parentId}&monthsBack=${monthsBack}`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Si le pedimos 2 months back por ejemplo, nos devolverá el mes actual + 2 meses anteriores.
  findByMonthsBackAndClinic(clinicID: string, clientID: string, monthsBack: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesByMonthsBack?entityType=clinic&clinicID=${clinicID}&clientID=${clientID}&monthsBack=${monthsBack}`;
    const token = localStorage.getItem('token') || '';

    const headers = {
      'X-Amz-Security-Token': token
    }

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url, { headers }).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

  // Si le pedimos 2 months back por ejemplo, nos devolverá el mes actual + 2 meses anteriores.
  findByMonthsBackAllDistributors(monthsBack: number): Observable<MonthlyChargeAccounting[]> {
    const url = `${BASE_URL}/montlhyChargesByMonthsBack?entityType=distributor&monthsBack=${monthsBack}`;

    return this.httpClient.get<{ months: MonthlyChargeAccounting[] }>(url).pipe(
      map((resp: { months: MonthlyChargeAccounting[] }) => resp.months)
    )
  }

}
